import { render, staticRenderFns } from "./fidelior-report.vue?vue&type=template&id=33070618&"
import script from "./fidelior-report.vue?vue&type=script&lang=js&"
export * from "./fidelior-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports